import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="container-seed section-pad text-center" data-testid="not-found-page">
      <div className="text-overline">Error 404</div>
      <h1 className="mt-4 font-display font-bold text-4xl sm:text-5xl text-slate-900">Page not found</h1>
      <p className="mt-4 text-slate-600 max-w-md mx-auto">
        The page you're looking for has moved or never existed. Let's get you back on track.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-3 px-6 rounded-lg"
        data-testid="not-found-home-btn"
      >
        Back to Home
      </Link>
    </section>
  );
}
